import React, { Component } from 'react'
import styled from 'styled-components'
import { injectState } from 'freactal'
import { Textfield, IconButton } from 'react-mdl'
import { Link } from 'react-router-dom'
import Panel from '../../components/Panel'
import DisplayError from '../../../components/DisplayError'
import SavingIndicator from '../../../components/SavingIndicator'
import TextListEditor from '../../components/TextListEditor'
import Button from '../../../components/Button'

const Saving = styled.div`
  position: absolute;
  top: 0.25em;
  right: 0.25em;
`

class FormativePracticalAssessmentPanel extends Component {
  state = this.getInitialState(this.props.task)
  componentWillReceiveProps({ task }) {
    if (task !== this.props.task && this.state.saved) {
      this.setState(this.getInitialState(task))
    }
  }
  getInitialState({ name, items, mapping }) {
    return {
      saved: true,
      name,
      items,
      mapping,
    }
  }
  handleChangeName = ({ target }) => {
    this.setState({ saved: false, name: target.value })
  }
  handleChangeTasks = items => {
    this.setState({ saved: false, items })
  }
  handleChangeMapping = mapping => {
    this.setState({ saved: false, mapping })
  }
  saveChanges = async () => {
    const { index } = this.props
    const { name, items } = this.state
    const formativePracticalTask = {
      name,
      items,
    }
    await this.props.onUpdate(formativePracticalTask, index)
    this.setState({ saved: true })
  }

  render() {
    const { name, saved, items } = this.state
    const {
      state: { updateFormativePracticalAssessmentTaskError: error },
      index,
    } = this.props
    return (
      <Panel>
        <Saving>
          <SavingIndicator saved={saved} error={error} />
        </Saving>
        <Link
          to={`./mapping/${index}`}
          style={{
            position: 'absolute',
            top: '1.75em',
            right: '0.25em',
          }}>
          <IconButton name="add" accent />
        </Link>
        <DisplayError msg="Error while saving" error={error} />
        <Textfield
          floatingLabel
          label="Formative Practical Assessment Task Name"
          onChange={this.handleChangeName}
          value={name || ''}
        />
        <h5>Tasks</h5>
        <p>
          Add a subtask to the list by adding a single '#' at the beginning of
          the text. To add a subtask to a subtask, add two '#' characters at the
          beginning of the text ('##').
        </p>
        <TextListEditor textList={items} onChange={this.handleChangeTasks} />
        <Button
          primary
          raised
          disabled={saved === true}
          onClick={this.saveChanges}>
          Save
        </Button>
      </Panel>
    )
  }
}
export default injectState(FormativePracticalAssessmentPanel)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/FormativePracticalAssessments/FormativePracticalAssessmentPanel.js